import { v4 as uuidv4 } from 'uuid';

export const getDeviceId = () => {
    const existing = localStorage.getItem('deviceId');
    if (existing) return existing;
    const newId = uuidv4();
    localStorage.setItem('deviceId', newId);
    return newId;
  };

  export const getBrowser = (ua) => {
    if (/chrome|crios/i.test(ua)) return 'Chrome';
    if (/safari/i.test(ua)) return 'Safari';
    if (/firefox|fxios/i.test(ua)) return 'Firefox';
    if (/edg/i.test(ua)) return 'Edge';
    if (/opera|opr/i.test(ua)) return 'Opera';
    return 'Other';
}